import type { SiteId } from '@beaded/models'

import * as apiUtils from '.'

// Paid per-site forecasting (#3982, spec 5). Hand-written mirror of the Zod
// output schemas in apps/api/src/ez/endpoints/forecastSubscription.ts.
export interface ForecastSubscriptionStatus {
  hasForecasting: boolean
  // Present only for the site organisation's purchaser (ORGANIZATION_ADMIN).
  manage?: {
    canPurchase: boolean
    refusal: string | null
    status: string | null
    cancelAtPeriodEnd: boolean | null
    currentPeriodEnd: string | null
    // The subscription's billing interval, from the same Stripe read.
    interval: string | null
    pendingCheckout: boolean
    organizationId: number
  }
}

export const getStatus = (
  siteId: SiteId,
  options?: Parameters<typeof apiUtils.GET>[1],
): Promise<ForecastSubscriptionStatus> =>
  apiUtils.GET(`/site/${siteId}/forecast-subscription`, options)

// No interval: the customer picks monthly or annual inside Stripe Checkout
// (spec 5.1; owner request 2026-10-02).
export const createCheckout = (
  siteId: SiteId,
): Promise<{ clientSecret: string }> =>
  apiUtils.POST(`/site/${siteId}/forecast-checkout`, {})

export const openBillingPortal = (
  organizationId: number,
  siteId: SiteId,
): Promise<{ url: string }> =>
  apiUtils.POST(`/org/${organizationId}/billing-portal-session`, { siteId })
